module.exports = __webpack_public_path__ + "static/media/_logo.af07467c.png";